export default __webpack_public_path__ + "static/media/question.d27f2ba9.png";